// src/config.js

export const config = {
  theme: {
    token: {
      fontFamily:
        "Geist, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial",
      fontSize: 16,
      lineHeight: 1.5,
      colorPrimary: "#0D47FF",
      colorBgBase: "#ffffff",
      colorTextBase: "#111827",
      colorTextSecondary: "#6b7280",
      colorBorder: "#e6e6e6",
      borderRadius: 8,
    },
    components: {
      Button: { controlHeight: 40 },
      Card: { borderRadius: 8 },
    },
  },
  apiBase: "http://localhost:8080",  // Example API base URL
  // Add other config properties here as needed (e.g., API URLs, routes, etc.)
};
